function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.0001 4.47783e-05C6.71687 4.47783e-05 0 6.71567 0 15.0002C0 21.6276 4.29799 27.2503 10.258 29.2337C11.0077 29.3726 11.2829 28.9083 11.2829 28.5122C11.2829 28.1545 11.269 26.9728 11.2625 25.7194C7.08947 26.6268 6.2089 23.9496 6.2089 23.9496C5.52656 22.2158 4.54341 21.7548 4.54341 21.7548C3.18245 20.8238 4.646 20.8429 4.646 20.8429C6.15227 20.9485 6.9454 22.3889 6.9454 22.3889C8.28326 24.6819 10.4545 24.0189 11.3105 23.6356C11.4451 22.6662 11.8338 22.0042 12.2628 21.6298C8.93107 21.2505 5.42869 19.9644 5.42869 14.2167C5.42869 12.5791 6.01466 11.2409 6.97421 10.1905C6.81846 9.81242 6.30503 8.28702 7.11952 6.22087C7.11952 6.22087 8.37913 5.81772 11.2456 7.75843C12.4421 7.42608 13.7254 7.25941 15.0001 7.2537C16.2749 7.25941 17.5591 7.42608 18.7579 7.75843C21.6209 5.81772 22.8787 6.22087 22.8787 6.22087C23.6952 8.28702 23.1815 9.81242 23.0258 10.1905C23.9876 11.2409 24.5696 12.5791 24.5696 14.2167C24.5696 19.978 21.0605 21.2466 17.7203 21.6179C18.2583 22.0834 18.7377 22.9963 18.7377 24.3957C18.7377 26.4028 18.7204 28.0181 18.7204 28.5122C18.7204 28.9113 18.9904 29.3791 19.7507 29.2318C25.7075 27.2461 30 21.6254 30 15.0002C30 6.71567 23.2841 4.47783e-05 15.0001 4.47783e-05"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.68126 21.5369C5.64823 21.6117 5.53099 21.6338 5.42418 21.5826C5.31538 21.5337 5.25427 21.4321 5.28954 21.3573C5.32183 21.2808 5.43933 21.2594 5.54788 21.3104C5.65692 21.3595 5.71902 21.4621 5.68126 21.5369Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.2889 22.2144C6.21736 22.2808 6.07752 22.25 5.98263 22.1451C5.88452 22.0406 5.86614 21.9007 5.93867 21.8334C6.01244 21.7673 6.14806 21.7984 6.24643 21.9027C6.34454 22.0085 6.36367 22.1474 6.2889 22.2144Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.88033 23.0785C6.78842 23.1423 6.63815 23.0825 6.54524 22.9491C6.45334 22.8157 6.45334 22.6557 6.54723 22.5916C6.64038 22.5275 6.78843 22.5854 6.88257 22.7176C6.97423 22.8532 6.97422 23.0132 6.88033 23.0785"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.69068 23.913C7.60846 24.0037 7.43334 23.9794 7.30517 23.8557C7.17401 23.7347 7.1375 23.5631 7.21997 23.4724C7.30318 23.3815 7.47929 23.4071 7.60846 23.5298C7.73862 23.6505 7.77836 23.8234 7.69068 23.913Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.80836 24.3977C8.7721 24.5152 8.60343 24.5686 8.43353 24.5187C8.26388 24.4672 8.15284 24.3296 8.18712 24.2109C8.2224 24.0927 8.3918 24.037 8.56294 24.0904C8.73235 24.1416 8.84363 24.2782 8.80836 24.3977Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0359 24.4877C10.0402 24.6114 9.8961 24.714 9.71775 24.7162C9.53841 24.7202 9.39334 24.6201 9.39136 24.4984C9.39136 24.3734 9.5322 24.2718 9.71154 24.2688C9.88989 24.2654 10.0359 24.3647 10.0359 24.4877Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1784 24.2931C11.1997 24.4138 11.0758 24.5377 10.8987 24.5708C10.7245 24.6026 10.5633 24.5281 10.5412 24.4083C10.5196 24.2846 10.6458 24.1607 10.8197 24.1286C10.997 24.0978 11.1558 24.1704 11.1784 24.2931"
});

function SvgGithub({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.8e5887f9.svg";
export { ForwardRef as ReactComponent };